const ScrollFade = {
    mounted() {
        this.scrollContent = this.el.querySelector("[data-scroll-content]");
        this.fadeGradientLeft = this.el.querySelector("[data-fade-gradient-left]");
        this.fadeGradientRight = this.el.querySelector("[data-fade-gradient-right]");

        if (!this.scrollContent || !this.fadeGradientLeft || !this.fadeGradientRight) return;

        this.updateFadeVisibility = () => {
            const hasOverflow = this.scrollContent.scrollWidth > this.scrollContent.clientWidth;

            if (!hasOverflow) {
                this.fadeGradientLeft.style.opacity = "0";
                this.fadeGradientRight.style.opacity = "0";
                return;
            }

            const scrollLeft = this.scrollContent.scrollLeft;
            const maxScroll = this.scrollContent.scrollWidth - this.scrollContent.clientWidth;

            const fadeDistance = 30;

            const leftProgress = Math.min(scrollLeft / fadeDistance, 1);
            const rightProgress = Math.min((maxScroll - scrollLeft) / fadeDistance, 1);

            this.fadeGradientLeft.style.opacity = leftProgress.toString();
            this.fadeGradientRight.style.opacity = rightProgress.toString();
        };

        this.updateFadeVisibility();

        this.scrollContent.addEventListener("scroll", this.updateFadeVisibility);

        const resizeObserver = new ResizeObserver(() => {
            this.updateFadeVisibility();
        });
        resizeObserver.observe(this.scrollContent);

        this.cleanup = () => {
            this.scrollContent.removeEventListener("scroll", this.updateFadeVisibility);
            resizeObserver.disconnect();
        };
    },

    updated() {
        if (this.updateFadeVisibility) {
            this.updateFadeVisibility();
        }
    },

    destroyed() {
        if (this.cleanup) {
            this.cleanup();
        }
    },
};

export default ScrollFade;
